<template>
  <div class="inner">
    <div class="head">
      <div class="title">{{ article.Title }}</div>
      <div class="time">
        {{ article.CreateTime }}
      </div>
      <div class="view">{{ $t("index.view") }}:{{ viewNumber }}</div>
    </div>
    <a-typography v-html="htmlContent"></a-typography>
  </div>
</template>

<script setup>
import { h, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { FolderOutlined } from "@ant-design/icons-vue";
import { FileOutlined } from "@ant-design/icons-vue";
import axios from "axios";

let route = useRoute();
let router = useRouter();

let folder = localStorage.getItem("folder");

const articleId = ref(route.params.id);
const parentId = ref(route.params.parentId);
const article = ref({});
const viewNumber = ref();

const current = ref([]);
const items = ref([]);
const openKeys = ref([]);
const htmlContent = ref();

function findStringInArrayId(searchString, array) {
  // 使用 findIndex 方法来查找数组中第一个满足条件的元素索引
  const index = array.findIndex((obj) => obj.Id === searchString);

  // 如果找到了，返回索引；否则返回 -1
  return index !== -1 ? index : -1;
}

axios
  .post("api/KnowledgeClassify/SaveTouristVolume", {
    KnowledgeId: articleId.value,
  })
  .then((response) => {
    if (response.data.code != 200) {
      message.error(response.data.info);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {});

axios
  .post("api/KnowledgeClassify/GetTouristVolume", {
    KnowledgeId: articleId.value,
  })
  .then((response) => {
    if (response.data.code != 200) {
      message.error(response.data.info);
    } else {
      viewNumber.value = response.data.ReturnData;
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {});

axios
  .post("api/KnowledgeClassify/GetContentsAllowAnonymous", {
    Id: "",
    NodeId: parentId.value,
    Title: "",
    Lable: "",
  })
  .then((response) => {
    if (response.data.code != 200) {
      message.error(response.data.info);
    } else {
      if (response.data.ReturnData.length > 0) {
        if (findStringInArrayId(articleId.value, response.data.ReturnData) != -1) {
          article.value =
            response.data.ReturnData[
              findStringInArrayId(articleId.value, response.data.ReturnData)
            ];
          htmlContent.value = article.value.HtmlContent;
          document.title = article.value.Title;
        }
      }
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {});

const back = () => {
  router.push({
    name: "folder",
    params: {
      id: folder,
    },
  });
};
</script>

<style scoped>
.menu {
  width: 20%;
  height: 100%;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.inner {
  margin: 20px auto 0px auto;
  width: 100%;
  max-width: 1230px;
  padding: 0px 15px;
}
.inner >>> img {
  max-width: 100%;
}
.inner >>> video {
  max-width: 100%;
}
.inner >>> span {
  text-wrap: wrap !important;
}
.inner >>> p {
  text-wrap: wrap !important;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.title {
  margin-top: 10px;
  line-height: 50px;
  font-size: 24px;
  font-weight: 700;
  color: black;
}
.time {
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  color: #999;
}
.view {
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  color: #999;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
}
</style>
